<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text=""></ion-back-button>
    </ion-buttons>
    <ion-title>{{'CREATE_NEW_CLUB' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content #content nopadding>
  <ion-card>
    <ion-card-content>
      <ion-item>
        <ion-input
          type="text"
          placeholder="{{ 'ENTER_GROUP_NAME' | translate }}"
          [(ngModel)]="groupName"
          style="background-color: transparent"
          labelPlacement="stacked"
        >
          <div slot="label">
            <ion-text color="primary">{{'GROUP_NAME' | translate}}</ion-text>
          </div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-label color="primary" position="stacked"
          >{{'EDIT_ENTRY_DESC' | translate}}</ion-label
        >
        <ion-textarea
          [autoGrow]="true"
          placeholder="{{ 'ENTER_GROUP_DESCR' | translate }}"
          [(ngModel)]="groupDesc"
        ></ion-textarea>
      </ion-item>

      <ion-list-header> {{'COLLECTIONS_FROM' | translate}} </ion-list-header>

      <ion-item>
        <ion-select
          slot="end"
          [(ngModel)]="selectedCountry"
          style="height: 50px"
          (ionChange)="onChangeCountry()"
          interface="popover"
        >
          <ion-select-option
            *ngFor="let country of collectionCountries"
            value="{{country.country_code}}"
            >{{country.country_name}}</ion-select-option
          >
        </ion-select>
      </ion-item>

      <ion-list radio-group>
        <ion-list-header> {{'GROUP_TYPE' | translate}} </ion-list-header>
        <ion-radio-group [(ngModel)]="groupType" value="P">
          <ion-item>
            <!-- <ion-label
              >{{'P' | translate}}<span
                ><p class="ion-text-wrap">{{'P_DESC' | translate}}</p></span
              ></ion-label
            > -->
            <ion-radio value="P"
              >{{'P' | translate}}<span
                ><p class="ion-text-wrap">{{'P_DESC' | translate}}</p></span
              ></ion-radio
            >
          </ion-item>
          <ion-item>
            <!-- <ion-label
              >{{'C' | translate}}<span
                ><p class="ion-text-wrap">{{'C_DESC' | translate}}</p></span
              ></ion-label
            > -->
            <ion-radio value="C"
              >{{'C' | translate}}<span
                ><p class="ion-text-wrap">{{'C_DESC' | translate}}</p></span
              ></ion-radio
            >
          </ion-item>
          <ion-item>
            <!-- <ion-label
              >{{'S' | translate}}<span
                ><p class="ion-text-wrap">{{'S_DESC' | translate}}</p></span
              ></ion-label
            > -->
            <ion-radio value="S"
              >{{'S' | translate}}<span
                ><p class="ion-text-wrap">{{'S_DESC' | translate}}</p></span
              ></ion-radio
            >
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <ion-item>
    <ion-row class="buttons-row">
      <ion-col size="6">
        <ion-button
          expand="block"
          fill="solid"
          (click)="createNewGroup()"
          color="secondary"
          >{{'CREATE_BUTTON' | translate}}</ion-button
        >
      </ion-col>

      <ion-col size="6">
        <ion-button
          expand="block"
          fill="solid"
          color="exme-red"
          (click)="dismiss()"
          >{{'CANCEL_BUTTON' | translate}}</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-item>
  <ion-row style="height: 20px"></ion-row>
</ion-content>
